/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import { View } from 'backbone.marionette';

import './RelocationPrintView.css'
import tmplRelocationPrintView from './RelocationPrintView.hbs';

const RelocationPrintView = View.extend({
  template: tmplRelocationPrintView,

  className: 'relocation-print-view',

  templateContext() {
    return {
      'isInternal': !EXTERNAL,
      'hasOrderCRSOwner': !!this.model.get('internalPOCs').orderCRSOwner.id,
      'hasOrderPackageCRSOwner': !!this.model.get('internalPOCs').orderPackageCRSOwner.id,
      'hasOrderPackageEPCOwner': !!this.model.get('internalPOCs').orderPackageEPCOwner.id,
      'showOrderPackageID': this.model.get('orderDetails').orderPackageId && !EXTERNAL
    }
  },

  onRender() {
    document.title = `EMS MFD Relocation Request Form - Order #${this.model.get('orderDetails').orderId}`
  }
});

export default RelocationPrintView;
